export default __webpack_public_path__ + "static/media/ic_glp_64.7cb26dd8.svg";